import { render, staticRenderFns } from "./FuncLayout.vue?vue&type=template&id=9138c7a2&scoped=true&"
import script from "./FuncLayout.vue?vue&type=script&lang=js&"
export * from "./FuncLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9138c7a2",
  null
  
)

export default component.exports